(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bewertungen"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;
    function initReveal(scope) {
      var cards = (scope || document).querySelectorAll('.rev__card:not([data-rv])');
      if (!cards.length) return;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var io = new IntersectionObserver(function (entries) {
        var k = 0;
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          io.unobserve(en.target);
          var el = en.target;
          el.style.opacity = '';
          var anim = el.animate(
            { opacity: [0, 1], transform: ['translateY(18px)', 'translateY(0)'] },
            { duration: 600, delay: Math.min(k++ * 90, 270), easing: 'cubic-bezier(.22,1,.36,1)', fill: 'backwards' }
          );
          anim.onfinish = function () { el.style.willChange = ''; };
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.01 });
      cards.forEach(function (el) {
        el.dataset.rv = '1';
        var r = el.getBoundingClientRect();
        if (r.top < vh * 0.9 && r.bottom > 0) return; /* schon sichtbar: nicht animieren, kein Aufpoppen */
        el.style.opacity = '0';
        el.style.willChange = 'transform, opacity';
        io.observe(el);
      });
    }
    if (document.readyState !== 'loading') initReveal();
    else document.addEventListener('DOMContentLoaded', function () { initReveal(); });
    document.addEventListener('shopify:section:load', function (e) { initReveal(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["editorial-duo-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHero(root) {
      if (root.dataset.eduoInit) return;
      root.dataset.eduoInit = '1';

      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
      var imgs = Array.prototype.slice.call(root.querySelectorAll('[data-img]'));
      var count = slides.length;
      if (!count) return;

      var prev = root.querySelector('[data-prev]');
      var next = root.querySelector('[data-next]');
      var dotsWrap = root.querySelector('[data-dots]');
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      var index = 0;
      slides.forEach(function (s, i) { if (s.classList.contains('is-active')) index = i; });

      var dots = [];
      if (dotsWrap) {
        slides.forEach(function (_, i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'eduo__dot';
          b.setAttribute('aria-label', 'Slide ' + (i + 1));
          b.addEventListener('click', function () { go(i); restart(); });
          dotsWrap.appendChild(b);
          dots.push(b);
        });
      }

      function render() {
        slides.forEach(function (s, i) {
          var a = i === index;
          s.classList.toggle('is-active', a);
          s.setAttribute('aria-hidden', a ? 'false' : 'true');
          s.querySelectorAll('a, button').forEach(function (el) { el.tabIndex = a ? 0 : -1; });
        });
        imgs.forEach(function (im, i) { im.classList.toggle('is-active', i === index); });
        dots.forEach(function (d, i) { d.classList.toggle('is-on', i === index); });
      }
      function go(i) { index = ((i % count) + count) % count; render(); }

      if (prev) prev.addEventListener('click', function () { go(index - 1); restart(); });
      if (next) next.addEventListener('click', function () { go(index + 1); restart(); });

      var timer = null;
      var speed = parseInt(root.getAttribute('data-speed'), 10) || 6000;
      var autoplay = root.getAttribute('data-autoplay') === 'true' && count > 1 && !reduce;
      function start() { if (!autoplay) return; stop(); timer = setInterval(function () { go(index + 1); }, speed); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function restart() { if (autoplay) start(); }

      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);

      root.__eduoSelect = function (id) {
        var target = root.querySelector('[data-block-id="' + id + '"]');
        var i = slides.indexOf(target);
        if (i > -1) { stop(); go(i); }
      };

      render();
      start();
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('.eduo').forEach(function (r) { initHero(r); });
    }

    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', function () { initAll(); });

    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
    document.addEventListener('shopify:block:select', function (e) {
      var root = e.target.closest ? e.target.closest('.eduo') : null;
      if (root && root.__eduoSelect) root.__eduoSelect(e.detail.blockId);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"]) return;
  try {
    
  (function () {
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function initFaq(item) {
      if (item.dataset.faqInit) return;
      item.dataset.faqInit = '1';
      var summary = item.querySelector('summary');
      var body = item.querySelector('.faqs__a');
      if (!summary || !body) return;
      var animating = false;

      function keyframes(expanded) {
        var cs = window.getComputedStyle(body);
        var full = {
          height: body.offsetHeight + 'px',
          paddingTop: cs.paddingTop, paddingBottom: cs.paddingBottom,
          opacity: 1
        };
        var zero = { height: '0px', paddingTop: '0px', paddingBottom: '0px', opacity: 0 };
        return expanded ? [zero, full] : [full, zero];
      }

      summary.addEventListener('click', function (e) {
        e.preventDefault();
        if (animating) return;
        if (reduced || typeof body.animate !== 'function') {
          item.open = !item.open;
          return;
        }
        animating = true;
        if (item.open) {
          var anim = body.animate(keyframes(false), { duration: 280, easing: 'ease' });
          anim.onfinish = anim.oncancel = function () { item.open = false; animating = false; };
        } else {
          item.open = true;
          var anim2 = body.animate(keyframes(true), { duration: 380, easing: 'cubic-bezier(.16,1,.3,1)' });
          anim2.onfinish = anim2.oncancel = function () { animating = false; };
        }
      });
    }

    function initMore(scope) {
      (scope || document).querySelectorAll('[data-faq-more]:not([data-init])').forEach(function (btn) {
        btn.dataset.init = '1';
        btn.addEventListener('click', function () {
          var sec = btn.closest('.faqs');
          if (!sec) return;
          var hiddenItems = sec.querySelectorAll('.faqs__item[hidden]');
          hiddenItems.forEach(function (el, i) {
            el.hidden = false;
            delete el.dataset.wasHidden;
            if (!reduced && typeof el.animate === 'function') {
              el.animate(
                { opacity: [0, 1], transform: ['translateY(14px)', 'translateY(0)'] },
                { duration: 450, delay: Math.min(i * 60, 300), easing: 'cubic-bezier(.22,1,.36,1)', fill: 'backwards' }
              );
            }
          });
          var wrap = btn.closest('.faqs__more');
          if (wrap) { wrap.hidden = true; wrap.dataset.done = '1'; }
        });
      });
    }

    function initSearch(scope) {
      (scope || document).querySelectorAll('[data-faq-search]:not([data-init])').forEach(function (input) {
        input.dataset.init = '1';
        var sec = input.closest('.faqs');
        if (!sec) return;
        var items = sec.querySelectorAll('.faqs__item');
        var noRes = sec.querySelector('[data-faq-noresult]');
        var moreWrap = sec.querySelector('.faqs__more');
        items.forEach(function (el) { if (el.hidden) el.dataset.wasHidden = '1'; });

        input.addEventListener('input', function () {
          var q = input.value.trim().toLowerCase();
          if (q === '') {
            /* Suche geleert: ursprünglichen Zustand wiederherstellen */
            items.forEach(function (el) {
              el.style.display = '';
              el.hidden = el.dataset.wasHidden === '1';
            });
            if (noRes) noRes.hidden = true;
            if (moreWrap && !moreWrap.dataset.done) moreWrap.hidden = false;
            return;
          }
          var hits = 0;
          items.forEach(function (el) {
            var match = el.textContent.toLowerCase().indexOf(q) !== -1;
            el.style.display = match ? '' : 'none';
            if (match) { el.hidden = false; hits++; }
          });
          if (noRes) noRes.hidden = hits !== 0;
          if (moreWrap) moreWrap.hidden = true;
        });
      });
    }

    /* Aus der Suche verlinkt (…/faq#frage-3): die Frage aufklappen, notfalls
       erst sichtbar machen, und sanft hinscrollen. Ohne das landet der Kunde
       zwar auf der Seite, muss die Frage aber selbst suchen. */
    function zieleAnspringen() {
      var hash = window.location.hash;
      if (!hash || hash.indexOf('#frage-') !== 0) return;
      var el = document.querySelector(hash);
      if (!el) return;
      if (el.hidden) {
        /* Steckt die Frage noch hinter „Alle Fragen anzeigen"? Dann aufdecken. */
        var mehr = el.closest('.faqs') && el.closest('.faqs').querySelector('[data-faq-more]');
        if (mehr) mehr.click();
        el.hidden = false;
      }
      el.open = true;
      setTimeout(function () {
        el.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
      }, 60);
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('.faqs__item').forEach(initFaq);
      initMore(scope);
      initSearch(scope);
      zieleAnspringen();
    }
    window.addEventListener('hashchange', zieleAnspringen);
    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', function () { initAll(); });
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
    /* Editor: angeklickte, noch versteckte Frage sichtbar machen */
    document.addEventListener('shopify:block:select', function (e) {
      var el = e.target && e.target.closest ? e.target.closest('.faqs__item') : null;
      if (el && el.hidden) el.hidden = false;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inspiration-galerie"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;
    function initReveal(scope) {
      var cards = (scope || document).querySelectorAll('.insp__card:not([data-rv])');
      if (!cards.length) return;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var io = new IntersectionObserver(function (entries) {
        var k = 0;
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          io.unobserve(en.target);
          var el = en.target;
          el.style.opacity = '';
          var anim = el.animate(
            { opacity: [0, 1], transform: ['translateY(20px)', 'translateY(0)'] },
            { duration: 650, delay: Math.min(k++ * 90, 270), easing: 'cubic-bezier(.22,1,.36,1)', fill: 'backwards' }
          );
          anim.onfinish = function () { el.style.willChange = ''; };
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.01 });
      cards.forEach(function (el) {
        el.dataset.rv = '1';
        var r = el.getBoundingClientRect();
        if (r.top < vh * 0.9 && r.bottom > 0) return; /* schon sichtbar: nicht animieren, kein Aufpoppen */
        el.style.opacity = '0';
        el.style.willChange = 'transform, opacity';
        io.observe(el);
      });
    }
    if (document.readyState !== 'loading') initReveal();
    else document.addEventListener('DOMContentLoaded', function () { initReveal(); });
    document.addEventListener('shopify:section:load', function (e) { initReveal(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kollektion-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;
    function initReveal(scope) {
      var tiles = (scope || document).querySelectorAll('.kgrid__tile:not([data-rv])');
      if (!tiles.length) return;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var io = new IntersectionObserver(function (entries) {
        var k = 0;
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          io.unobserve(en.target);
          var el = en.target;
          el.style.opacity = '';
          var anim = el.animate(
            { opacity: [0, 1], transform: ['translateY(18px)', 'translateY(0)'] },
            { duration: 600, delay: Math.min(k++ * 80, 240), easing: 'cubic-bezier(.22,1,.36,1)', fill: 'backwards' }
          );
          anim.onfinish = function () { el.style.willChange = ''; };
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.01 });
      tiles.forEach(function (el) {
        el.dataset.rv = '1';
        var r = el.getBoundingClientRect();
        if (r.top < vh * 0.9 && r.bottom > 0) return; /* schon sichtbar: nicht animieren, kein Aufpoppen */
        el.style.opacity = '0';
        el.style.willChange = 'transform, opacity';
        io.observe(el);
      });
    }
    if (document.readyState !== 'loading') initReveal();
    else document.addEventListener('DOMContentLoaded', function () { initReveal(); });
    document.addEventListener('shopify:section:load', function (e) { initReveal(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["montage-videos"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(scope) {
      var buttons = (scope || document).querySelectorAll('[data-mvid-play]:not([data-mvid-init])');
      buttons.forEach(function (btn) {
        btn.dataset.mvidInit = '1';
        btn.addEventListener('click', function () {
          /* Hochgeladenes Video: direkt abspielen, keine Daten an Dritte */
          var file = btn.dataset.videoSrc;
          if (file) {
            var v = document.createElement('video');
            v.src = file;
            v.controls = true; v.autoplay = true; v.playsInline = true;
            btn.innerHTML = '';
            btn.appendChild(v);
            btn.style.cursor = 'default';
            return;
          }
          var id = btn.dataset.videoId;
          var type = btn.dataset.videoType;
          if (!id) return;
          var src = type === 'vimeo'
            ? 'https://player.vimeo.com/video/' + id + '?autoplay=1&dnt=1'
            : 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0';
          var iframe = document.createElement('iframe');
          iframe.src = src;
          iframe.title = btn.getAttribute('aria-label') || 'Video';
          iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen';
          iframe.allowFullscreen = true;
          btn.innerHTML = '';
          btn.appendChild(iframe);
          btn.style.cursor = 'default';
        }, { once: true });
      });
    }
    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', function () { init(); });
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["produkt-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSlider(root) {
      if (root.dataset.psInit) return;
      root.dataset.psInit = '1';
      var track = root.querySelector('[data-ps-track]');
      var prev = root.querySelector('[data-ps-prev]');
      var next = root.querySelector('[data-ps-next]');
      if (!track) return;
      function step() {
        var card = track.querySelector('.pslide__card');
        return card ? card.getBoundingClientRect().width + 18 : 320;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });

      /* ---- Kategorie-Chips ------------------------------------------------
         Klick auf einen Chip blendet alle Karten anderer Kategorien aus und
         lenkt gleichzeitig den "Alle Produkte ansehen"-Button auf die
         gefilterte Kategorieseite um. So landet der Kunde nicht wieder im
         gemischten Bestseller-Topf. */
      var filterBar = root.querySelector('[data-ps-filter]');
      if (!filterBar) return;
      var chips = Array.prototype.slice.call(filterBar.querySelectorAll('[data-ps-chip]'));
      var karten = Array.prototype.slice.call(track.querySelectorAll('.pslide__card'));
      var leerHinweis = root.querySelector('[data-ps-filter-empty]');
      var cta = root.querySelector('[data-ps-cta]');

      function setze(typ) {
        var sichtbar = 0;
        karten.forEach(function (li) {
          var passt = !typ || li.dataset.psTyp === typ;
          li.hidden = !passt;
          if (passt) sichtbar++;
        });
        chips.forEach(function (c) {
          var aktiv = (c.dataset.psChip || '') === (typ || '');
          c.classList.toggle('is-active', aktiv);
          c.setAttribute('aria-pressed', aktiv ? 'true' : 'false');
        });
        if (leerHinweis) leerHinweis.hidden = sichtbar !== 0;
        track.scrollTo({ left: 0, behavior: 'smooth' });

        if (cta) {
          var basis = cta.dataset.baseUrl || '#';
          if (typ && basis !== '#') {
            /* Standard-Filterparameter von Shopify (Search & Discovery).
               Ist der Filter im Admin nicht aktiviert, zeigt die Seite
               einfach die ungefilterte Kategorie – nichts geht kaputt. */
            var trenner = basis.indexOf('?') === -1 ? '?' : '&';
            cta.href = basis + trenner + 'filter.p.product_type=' + encodeURIComponent(typ);
            cta.textContent = 'Alle ' + typ + ' ansehen';
          } else {
            cta.href = basis;
            cta.textContent = cta.dataset.baseLabel || cta.textContent;
          }
        }
      }

      chips.forEach(function (c) {
        c.addEventListener('click', function () { setze(c.dataset.psChip || ''); });
      });
    }
    function initAll(scope) {
      (scope || document).querySelectorAll('.pslide').forEach(initSlider);
    }
    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', function () { initAll(); });
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["produkt-videos"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Klick auf eine Vorschau-Kachel öffnet das Video groß im Overlay.
       Bei Instagram/TikTok wird der Embed dabei erst jetzt geladen – vorher
       gehen keine Daten an Meta oder TikTok (DSGVO). */
    function init(scope) {
      (scope || document).querySelectorAll('.pvid:not([data-pvid-init])').forEach(function (root) {
        root.dataset.pvidInit = '1';
        var box = root.querySelector('[data-pvid-lightbox]');
        if (!box) return;
        var frame = box.querySelector('[data-pvid-frame]');
        var caption = box.querySelector('[data-pvid-caption]');
        var zuletzt = null;

        function zu() {
          box.hidden = true;
          frame.innerHTML = '';          /* stoppt Video bzw. entlädt den Embed */
          caption.textContent = '';
          document.documentElement.style.overflow = '';
          if (zuletzt) zuletzt.focus();
          zuletzt = null;
        }

        function auf(btn) {
          zuletzt = btn;
          frame.innerHTML = '';
          var typ = btn.dataset.pvidTyp;
          var src = btn.dataset.pvidSrc;
          if (!src) return;

          if (typ === 'datei') {
            var v = document.createElement('video');
            v.src = src;
            v.controls = true; v.autoplay = true; v.playsInline = true;
            frame.appendChild(v);
          } else {
            var iframe = document.createElement('iframe');
            iframe.src = src;
            iframe.title = btn.dataset.pvidTitel || 'Video';
            iframe.allow = 'autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share; fullscreen';
            iframe.setAttribute('allowfullscreen', '');
            iframe.setAttribute('scrolling', 'no');
            frame.appendChild(iframe);
          }

          var teile = [];
          if (btn.dataset.pvidTitel) teile.push(btn.dataset.pvidTitel);
          if (btn.dataset.pvidDienst) teile.push('Eingebettet von ' + btn.dataset.pvidDienst + '.');
          caption.textContent = teile.join(' · ');

          box.hidden = false;
          document.documentElement.style.overflow = 'hidden';
          var x = box.querySelector('.pvid__lb-x');
          if (x) x.focus();
        }

        root.querySelectorAll('[data-pvid-open]').forEach(function (btn) {
          btn.addEventListener('click', function () { auf(btn); });
        });
        box.querySelectorAll('[data-pvid-close]').forEach(function (b) {
          b.addEventListener('click', zu);
        });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && !box.hidden) zu();
        });
      });
    }
    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', function () { init(); });
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["schritte-prozess"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;
    function initReveal(scope) {
      var cards = (scope || document).querySelectorAll('.steps__card:not([data-rv])');
      if (!cards.length) return;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var io = new IntersectionObserver(function (entries) {
        var k = 0;
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          io.unobserve(en.target);
          var el = en.target;
          el.style.opacity = '';
          var anim = el.animate(
            { opacity: [0, 1], transform: ['translateY(18px)', 'translateY(0)'] },
            { duration: 600, delay: Math.min(k++ * 90, 270), easing: 'cubic-bezier(.22,1,.36,1)', fill: 'backwards' }
          );
          anim.onfinish = function () { el.style.willChange = ''; };
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.01 });
      cards.forEach(function (el) {
        el.dataset.rv = '1';
        var r = el.getBoundingClientRect();
        if (r.top < vh * 0.9 && r.bottom > 0) return; /* schon sichtbar: nicht animieren, kein Aufpoppen */
        el.style.opacity = '0';
        el.style.willChange = 'transform, opacity';
        io.observe(el);
      });
    }
    if (document.readyState !== 'loading') initReveal();
    else document.addEventListener('DOMContentLoaded', function () { initReveal(); });
    document.addEventListener('shopify:section:load', function (e) { initReveal(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["suchleiste"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function el(tag, cls, text) {
      var n = document.createElement(tag);
      if (cls) n.className = cls;
      if (text != null) n.textContent = text;
      return n;
    }
    /* Maßprodukte rechnen in Einheiten: Der Variantenpreis ist ein Hundertstel
       des m²-/Meterpreises. Welche das sind, steht im data-Attribut der Box. */
    function einheitenKarte(box) {
      var karte = {};
      (box.dataset.einheiten || '').split('|').forEach(function (teil) {
        var i = teil.indexOf('=');
        if (i > 0) karte[teil.slice(0, i).trim()] = teil.slice(i + 1).trim();
      });
      return karte;
    }
    function fmtPrice(v, url, karte) {
      var f = parseFloat(v);
      if (isNaN(f)) return '';
      var m = String(url || '').match(/\/products\/([^/?#]+)/);
      var einheit = m && karte ? karte[m[1]] : null;
      if (einheit) {
        var hoch = f * 100;
        var txt = hoch % 1 === 0 ? String(hoch) : hoch.toFixed(2).replace('.', ',');
        return txt + ' € ' + einheit;
      }
      return f.toFixed(2).replace('.', ',') + ' €';
    }

    /* ---- Fehlertolerante Suche: Tippfehler + Umformulierungen ---- */
    var WORTE = ['gardine','gardinen','vorhang','vorhänge','verdunkelungsvorhang','verdunkelung','blickdicht','transparent','blackout','dimmout','jalousie','jalousien','holzjalousien','alujalousien','vertikaljalousien','plissee','plissees','wabenplissee','wabenplissees','insektenschutz','stoffmuster','muster','musterset','zubehör','kräuselband','ösen','schlaufen','messen','maßanfertigung','beige','blau','grau','weiß','anthrazit'];
    var SYNONYME = {
      'fliegengitter':'insektenschutz','fliegenschutz':'insektenschutz','fliegennetz':'insektenschutz',
      'mueckenschutz':'insektenschutz','mueckengitter':'insektenschutz','muecken':'insektenschutz',
      'moskitonetz':'insektenschutz','insektengitter':'insektenschutz','insekten':'insektenschutz','fliegen':'insektenschutz',
      'rollo':'plissee','rollos':'plissees','raffrollo':'plissee','faltrollo':'plissee','faltstore':'plissee',
      'sonnenschutz':'plissee','sichtschutz':'plissee',
      'lamellen':'jalousien','lamellenvorhang':'vertikaljalousien',
      'uebergardine':'vorhang','uebergardinen':'vorhänge','schal':'vorhang','schals':'vorhänge',
      'stores':'gardinen','fensterdeko':'gardinen',
      'verdunklung':'verdunkelung','abdunkelung':'verdunkelung','abdunklung':'verdunkelung',
      'verdunkeln':'verdunkelung','dunkel':'verdunkelung','dunkler':'verdunkelung'
    };
    function fold(w) {
      return w.toLowerCase().replace(/ä/g,'ae').replace(/ö/g,'oe').replace(/ü/g,'ue').replace(/ß/g,'ss');
    }
    function dist(a, b) {
      if (Math.abs(a.length - b.length) > 2) return 9;
      var m = [], i, j;
      for (i = 0; i <= a.length; i++) { m[i] = [i]; }
      for (j = 0; j <= b.length; j++) { m[0][j] = j; }
      for (i = 1; i <= a.length; i++) {
        for (j = 1; j <= b.length; j++) {
          m[i][j] = Math.min(m[i-1][j] + 1, m[i][j-1] + 1, m[i-1][j-1] + (a[i-1] === b[j-1] ? 0 : 1));
        }
      }
      return m[a.length][b.length];
    }
    function korrigiere(q) {
      var geaendert = false;
      var out = q.trim().split(/\s+/).map(function (w) {
        var f = fold(w);
        if (SYNONYME[f]) { geaendert = true; return SYNONYME[f]; }
        if (w.length < 4) return w;
        var maxD = f.length <= 5 ? 1 : 2, best = null, bestD = maxD + 1, i, d, dw;
        for (i = 0; i < WORTE.length; i++) {
          dw = fold(WORTE[i]);
          if (dw === f || dw.indexOf(f) === 0) return w;
          d = dist(f, dw);
          if (d < bestD) { bestD = d; best = WORTE[i]; }
        }
        if (best && bestD <= maxD) { geaendert = true; return best; }
        return w;
      });
      return { q: out.join(' '), geaendert: geaendert };
    }

    function init(scope) {
      var boxes = (scope || document).querySelectorAll('[data-sbar]:not([data-sbar-init])');
      boxes.forEach(function (box) {
        box.dataset.sbarInit = '1';
        var input = box.querySelector('[data-sbar-input]');
        var panel = box.querySelector('[data-sbar-results]');
        if (!input || !panel) return;
        var suggestUrl = box.dataset.suggestUrl || '/search/suggest';
        var searchUrl = box.dataset.searchUrl || '/search';
        var FAQ_FALLBACK = box.dataset.faqUrl || '/pages/faq';
        var EINHEITEN = einheitenKarte(box);
        var types = box.dataset.types || 'product';
        var timer = null, ctrl = null, korrektur = null;

        function close() { panel.hidden = true; }

        function zaehle(res) {
          var t = 0;
          ['products', 'collections', 'pages', 'articles'].forEach(function (k) {
            if (res && res[k]) t += res[k].length;
          });
          return t;
        }
        function anfrage(q) {
          var url = suggestUrl + '.json?q=' + encodeURIComponent(q) +
            '&resources[type]=' + encodeURIComponent(types) +
            '&resources[limit]=5&resources[options][unavailable_products]=last';
          return fetch(url, ctrl ? { signal: ctrl.signal } : {})
            .then(function (r) { return r.json(); })
            .then(function (d) { return d.resources.results; });
        }

        function linkItem(x) {
          var a = el('a', 'sbar__item');
          a.href = x.url;
          var c = el('span', 'sbar__copy');
          c.appendChild(el('strong', null, x.title));
          a.appendChild(c);
          return a;
        }

        function render(q, res, original) {
          panel.innerHTML = '';
          var total = 0;

          /* FAQ-Verweise zuerst: „Lieferzeit", „Versandkosten", „Rückgabe" …
             haben kein Produkt und keine Seite. Hier steht KEINE Antwort,
             sondern der Weg dorthin. Das FAQ wird immer mit angeboten. */
          var qaHits = window.almazQA ? window.almazQA(original || q) : [];
          var qaGroup = el('div', 'sbar__group');
          qaGroup.appendChild(el('p', 'sbar__label', 'Hilfe & Fragen'));
          if (window.almazQARender) {
            qaHits.forEach(function (e) { qaGroup.appendChild(window.almazQARender(e, 'sbar__')); });
          }
          if (window.almazQAFaqZeile) {
            qaGroup.appendChild(window.almazQAFaqZeile('sbar__'));
          } else {
            /* Ohne FAQ-Sektion im Fußbereich kennt diese Seite die Fragen
               nicht – der Weg zum FAQ soll trotzdem nie fehlen. */
            var fb = el('a', 'sbar__qa sbar__qa--alle');
            fb.href = FAQ_FALLBACK;
            var fbq = el('span', 'sbar__qa-q', '?'); fbq.setAttribute('aria-hidden', 'true');
            fb.appendChild(fbq);
            fb.appendChild(el('strong', 'sbar__qa-title', 'Häufige Fragen'));
            fb.appendChild(el('span', 'sbar__qa-link', 'Lieferzeit, Messen, Rückgabe – alle Antworten →'));
            qaGroup.appendChild(fb);
          }
          panel.appendChild(qaGroup);
          total += qaHits.length;

          if (original) {
            panel.appendChild(el('p', 'sbar__korr', 'Zu „' + original + '“ haben wir nichts gefunden – hier sind Treffer für „' + q + '“:'));
          }
          function group(label, items, build) {
            if (!items || !items.length) return;
            total += items.length;
            var g = el('div', 'sbar__group');
            g.appendChild(el('p', 'sbar__label', label));
            items.forEach(function (it) { g.appendChild(build(it)); });
            panel.appendChild(g);
          }
          group('Produkte', res.products, function (p) {
            var a = el('a', 'sbar__item');
            a.href = p.url;
            if (p.image) {
              var im = document.createElement('img');
              im.src = p.image; im.alt = ''; im.loading = 'lazy'; im.className = 'sbar__thumb';
              a.appendChild(im);
            }
            var c = el('span', 'sbar__copy');
            c.appendChild(el('strong', null, p.title));
            var pr = fmtPrice(p.price, p.url, EINHEITEN);
            if (pr) c.appendChild(el('small', null, 'ab ' + pr));
            a.appendChild(c);
            return a;
          });
          group('Kategorien', res.collections, linkItem);
          group('Seiten', res.pages, linkItem);
          group('Ratgeber', res.articles, linkItem);
          if (total === 0) panel.appendChild(el('p', 'sbar__none', 'Keine Treffer für „' + q + '“.'));
          var all = el('a', 'sbar__all', 'Alle Ergebnisse ansehen');
          all.href = searchUrl + '?q=' + encodeURIComponent(q);
          panel.appendChild(all);
          panel.hidden = false;
        }

        /* Leeres Suchfeld: die ersten vier FAQ-Fragen als Startvorschlag.
           Ein leeres Dropdown ist eine verschenkte Gelegenheit – hier stehen
           genau die Fragen, die Leute sonst vom Kauf abhalten. Sobald jemand
           tippt, verschwinden sie und es zählen nur noch echte Treffer. */
        function startvorschlag() {
          panel.innerHTML = '';
          if (!window.almazQAErste || !window.almazQARender) { panel.hidden = true; return; }
          var erste = window.almazQAErste(4);
          if (!erste.length) { panel.hidden = true; return; }
          var g = el('div', 'sbar__group');
          g.appendChild(el('p', 'sbar__label', 'Häufig gefragt'));
          erste.forEach(function (e) { g.appendChild(window.almazQARender(e, 'sbar__')); });
          if (window.almazQAFaqZeile) { g.appendChild(window.almazQAFaqZeile('sbar__')); }
          panel.appendChild(g);
          panel.hidden = false;
        }
        input.addEventListener('focus', function () {
          if (input.value.trim().length < 2) startvorschlag();
        });

        input.addEventListener('input', function () {
          clearTimeout(timer);
          var q = input.value.trim();
          korrektur = null;
          if (q.length < 2) { startvorschlag(); return; }
          timer = setTimeout(function () {
            if (ctrl) ctrl.abort();
            ctrl = window.AbortController ? new AbortController() : null;
            function fehler(err) { if (err && err.name === 'AbortError') return; close(); }
            anfrage(q).then(function (res) {
              if (zaehle(res) > 0) { render(q, res, null); return; }
              var k = korrigiere(q);
              if (!k.geaendert || fold(k.q) === fold(q)) { render(q, res, null); return; }
              anfrage(k.q).then(function (res2) {
                if (zaehle(res2) > 0) { korrektur = k.q; render(k.q, res2, q); }
                else { render(q, res, null); }
              }).catch(fehler);
            }).catch(fehler);
          }, 250);
        });
        /* Bei Enter: korrigierten Begriff mitgeben, wenn er benutzt wurde */
        var form = box.querySelector('form[role="search"]');
        if (form) form.addEventListener('submit', function () {
          if (korrektur) input.value = korrektur;
        });
        input.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
        document.addEventListener('click', function (e) { if (!box.contains(e.target)) close(); });
      });
    }
    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', function () { init(); });
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["usp-leiste"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;
    function initReveal(scope) {
      var items = (scope || document).querySelectorAll('.uspl__item:not([data-rv])');
      if (!items.length) return;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var io = new IntersectionObserver(function (entries) {
        var k = 0;
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          io.unobserve(en.target);
          var el = en.target;
          el.style.opacity = '';
          var anim = el.animate(
            { opacity: [0, 1], transform: ['translateY(18px)', 'translateY(0)'] },
            { duration: 550, delay: Math.min(k++ * 80, 240), easing: 'cubic-bezier(.22,1,.36,1)', fill: 'backwards' }
          );
          anim.onfinish = function () { el.style.willChange = ''; };
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.01 });
      items.forEach(function (el) {
        el.dataset.rv = '1';
        var r = el.getBoundingClientRect();
        if (r.top < vh * 0.9 && r.bottom > 0) return; /* schon sichtbar: nicht animieren, kein Aufpoppen */
        el.style.opacity = '0';
        el.style.willChange = 'transform, opacity';
        io.observe(el);
      });
    }
    if (document.readyState !== 'loading') initReveal();
    else document.addEventListener('DOMContentLoaded', function () { initReveal(); });
    document.addEventListener('shopify:section:load', function (e) { initReveal(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vorher-nachher"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCompare(scope) {
      var boxes = (scope || document).querySelectorAll('.vns__compare[data-vns]:not([data-vns-init])');
      boxes.forEach(function (box) {
        box.dataset.vnsInit = '1';
        var range = box.querySelector('.vns__range');
        if (!range) return;
        function setPos(val) {
          var v = Math.max(0, Math.min(100, parseFloat(val) || 0));
          box.style.setProperty('--pos', v + '%');
        }
        range.addEventListener('input', function () { setPos(range.value); });
        setPos(range.value);
      });

      /* Kleiner Hinweis-Effekt beim ersten Sichtbarwerden: Griff gleitet zur Startposition */
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (!('IntersectionObserver' in window)) return;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          io.unobserve(en.target);
          nudge(en.target);
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.2 });
      boxes.forEach(function (box) {
        if (box.dataset.vnsNudged) return;
        box.dataset.vnsNudged = '1';
        var r = box.getBoundingClientRect();
        if (r.top < vh * 0.9 && r.bottom > 0) return; /* schon sichtbar: nicht animieren */
        io.observe(box);
      });
      function nudge(box) {
        var range = box.querySelector('.vns__range');
        if (!range) return;
        var target = parseFloat(range.value) || 50;
        var from = Math.min(target + 32, 96);
        var start = null;
        var dur = 900;
        function step(ts) {
          if (box.dataset.vnsTouched) return; /* Nutzer hat schon gezogen */
          if (start === null) start = ts;
          var t = Math.min((ts - start) / dur, 1);
          var e = 1 - Math.pow(1 - t, 3);
          var v = from + (target - from) * e;
          box.style.setProperty('--pos', v + '%');
          if (t < 1) requestAnimationFrame(step);
        }
        range.addEventListener('input', function () { box.dataset.vnsTouched = '1'; }, { once: true });
        requestAnimationFrame(step);
      }
    }
    if (document.readyState !== 'loading') initCompare();
    else document.addEventListener('DOMContentLoaded', function () { initCompare(); });
    document.addEventListener('shopify:section:load', function (e) { initCompare(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zahlen-fakten"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function formatDe(n) {
      return Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }
    function countUp(el, target) {
      var dur = 1400;
      var start = null;
      function step(ts) {
        if (start === null) start = ts;
        var t = Math.min((ts - start) / dur, 1);
        var e = 1 - Math.pow(1 - t, 3);
        el.textContent = formatDe(target * e);
        if (t < 1) requestAnimationFrame(step);
        else el.textContent = formatDe(target);
      }
      requestAnimationFrame(step);
    }
    function initCounts(scope) {
      var nums = (scope || document).querySelectorAll('[data-zf-count]:not([data-zf-init])');
      if (!nums.length) return;
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      nums.forEach(function (el) {
        el.dataset.zfInit = '1';
        var target = parseFloat(el.dataset.zfCount) || 0;
        el.textContent = formatDe(target);
        if (reduced || !('IntersectionObserver' in window)) return;
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (!en.isIntersecting) return;
            io.unobserve(en.target);
            countUp(el, target);
          });
        }, { threshold: 0.4 });
        io.observe(el);
      });
    }
    if (document.readyState !== 'loading') initCounts();
    else document.addEventListener('DOMContentLoaded', function () { initCounts(); });
    document.addEventListener('shopify:section:load', function (e) { initCounts(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
